export default __webpack_public_path__ + "static/media/QuestionMark.d54cdb31.svg";